
import Routers from "./Routers"
// firebase deploy --only hosting:user-aiot-smartlocker
const App = () => {

  return <><Routers /></>;
};

export default App;
